import { render } from "./ShippingAndReturnsV2.vue?vue&type=template&id=12c1f234&scoped=true"
import script from "./ShippingAndReturnsV2.vue?vue&type=script&lang=js"
export * from "./ShippingAndReturnsV2.vue?vue&type=script&lang=js"

import "./ShippingAndReturnsV2.vue?vue&type=style&index=0&id=12c1f234&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c1f234"]])

export default __exports__